const baseApiUrl = process.env.REACT_APP_API_URL;
const baseVersion = process.env.REACT_APP_VERSION_API;

const baseUrl = `${baseApiUrl}/${baseVersion}`;

export const API_URLS = Object.freeze({
  LOGIN: `${baseUrl}/admin/auth/login`,
  REFRESH_TOKEN: `${baseUrl}/auth/token/refresh`,
  LOGOUT: `${baseUrl}/auth/logout`,
  /** TOUR TRASH */
  SAVE_TOUR_TRASH: `${baseUrl}/admin/tour-trash/save`,
  TOUR_TRASH_LIST: `${baseUrl}/admin/tour-trash/list`,
  TOUR_TRASH_ENTERED_USERS: `${baseUrl}/admin/tour-trash/entered-email`,
  DELETE_TOURTRASH: `${baseUrl}/admin/tour-trash/delete`,
  ARCHIVE_TOURTRASH: `${baseUrl}/admin/tour-trash/archive`,
  ACTIVATE_TOURTRASH: `${baseUrl}/admin/tour-trash/active`,
  CLOSE_TOURTRASH: `${baseUrl}/admin/tour-trash/close`,
  CANCEL_TOURTRASH: `${baseUrl}/admin/tour-trash/cancel`,
  TOURTRASH_PICK_WINNER: `${baseUrl}/admin/tour-trash/winner/pick`,
  TOURTRASH_SELECT_RANDOM_WINNER: `${baseUrl}/admin/tour-trash/winner/select-random`,
  /** USER ME ADMIN */
  USER_ME: `${baseUrl}/admin/me`,
  /** ACTIVITY LOG */
  ACTIVITY_LOG: `${baseUrl}/logging/activity/all`,
  /** HOME WIDGETS */
  HOME_WIDGETS: `${baseUrl}/admin/home-widgets`,
  CREATE_HOME_WIDGETS: `${baseUrl}/admin/home-widgets/create`,
  UPDATE_HOME_WIDGETS: `${baseUrl}/admin/home-widgets/update`,
  SORT_HOME_WIDGETS: `${baseUrl}/admin/home-widgets/sort`,
  DELETE_HOME_WIDGETS: `${baseUrl}/admin/home-widgets/delete`,
  /** PROMOTION */
  PROMOTION_LIST: `${baseUrl}/promotion/get-all`,
  PROMOTION_API: `${baseUrl}/promotion`,
  PROMOTION_URL_WITH_ID: (id: string) => `${baseUrl}/promotion/${id}`,
  /** TRY THEN BUY */
  TRY_THEN_BUY_LIST: `${baseUrl}/ttb/orders-admin`,
  CANCEL_TRY_THEN_BUY: `${baseUrl}/ttb/admin-cancel`,
  PAUSE_TRY_THEN_BUY: `${baseUrl}/ttb/pause`,
  RESUME_TRY_THEN_BUY: `${baseUrl}/ttb/resume`,
  CLOSE_TRY_THEN_BUY: `${baseUrl}/ttb/gvc/returned`,
  /** TRY THEN BUY FRAUD */
  TRY_THEN_BUY_FRAUD_LIST: `${baseUrl}/ttb/orders-admin-fraud`,
  CANCEL_TRY_THEN_BUY_FRAUD: `${baseUrl}/ttb/orders-admin-fraud/cancel`,
  NOTE_TRY_THEN_BUY_FRAUD: `${baseUrl}/ttb/orders-admin-fraud/note`,
  CONFIG_THRESHOLD: `${baseUrl}/ttb/config-threshold`,
  /** NOTIFICATION */
  FCM_SUBSCRIBE: `${baseUrl}/admin/fcm/subscribe`,
  /** ACCESS_CODE */
  ACCESS_CODE_LIST: `${baseUrl}/admin/access-code/all`,
  ACCESS_CODE_GENERATE: `${baseUrl}/admin/access-code/generate`,
  ACCESS_CODE_GENERATE_MULTI: `${baseUrl}/admin/access-code/generate-multi`,
  ACCESS_CODE_DEACTIVATE: `${baseUrl}/admin/access-code/deactivate`,
  ACCESS_CODE_PURPOSE: `${baseUrl}/admin/access-code/get-purpose`,
  /** ECOM */
  ECOM_GET_PRODUCT_ALL: `${baseUrl}/ecom/product/all`,
  /** TRANSLATION */
  TRANSLATION_SYNC: (onlyLanguage?: string) =>
    `${baseUrl}/admin/translations/sync${onlyLanguage ? `?onlyLanguage=${onlyLanguage}` : ''}`,
  /** EXTERNAL_TOOLS */
  EXTERNAL_TOOLS: `${baseUrl}/admin/external-tools`,
  EXTERNAL_TOOLS_SAVE: `${baseUrl}/admin/external-tools/save`,
  EXTERNAL_TOOLS_DELETE: `${baseUrl}/admin/external-tools/delete`,
  /** SHOP PRODUCT */
  PRODUCT_ORDERS: `${baseUrl}/shop/products/overwriteEcom`,
  SORT_PRODUCT_ORDERS: `${baseUrl}/shop/products/sort`,
  UPDATE_PRODUCT_SOLD_OUT: `${baseUrl}/shop/products/soldOut`,
  UPDATE_PRODUCT_FROM_ECOM: `${baseUrl}/shop/products/adminPortal`,
  UPDATE_PRODUCT_OVERWRITE: (id: string) => `${baseUrl}/shop/products/${id}`,
  /** BENEFITS */
  BENEFIT_LIST: `${baseUrl}/benefits/get-all`,
  BENEFIT_API: `${baseUrl}/benefits`,
  BENEFIT_SORT: `${baseUrl}/benefits/sort`,
  BENEFIT_URL_WITH_ID: (id: string) => `${baseUrl}/benefits/${id}`,
  /** PARTNERS */
  PARTNER_LIST: `${baseUrl}/partners/get-all`,
  PARTNER_API: `${baseUrl}/partners`,
  PARTNER_URL_WITH_ID: (id: string) => `${baseUrl}/partners/${id}`,
  /** LAUNCH_FEATURES */
  LAUNCH_FEATURES_LIST: `${baseUrl}/launch-features`,
  LAUNCH_FEATURES_SAVE: `${baseUrl}/launch-features/save`,
  SHOW_HIDE_FEATURES_LIST: `${baseUrl}/launch-features/country-features`,
  PAID_FEATURES: `${baseUrl}/launch-features/paid-features`,
  PAID_FEATURES_SAVE: `${baseUrl}/launch-features/save-paid-feature`,
  /** LOYALTY_ACTION */
  LOYALTY_ACTION_LIST: `${baseUrl}/loyalty/actions`,
  LOYALTY_ACTION_SAVE: `${baseUrl}/loyalty/action`,
  LOYALTY_ACTION_URL_WITH_ID: (actionId: string) => `${baseUrl}/loyalty/action/${actionId}`,

  /** COUNTRY */
  COUNTRY_LIST: `${baseUrl}/countries`,

  /** USER PROFILE */
  USER_PROFILE: `${baseUrl}/user-profile`,
  USER_PROFILE_UPDATE: (userId: string) => `${baseUrl}/admin/user-profile/update/${userId}`,
  USER_BLACKLIST: `${baseUrl}/user-black-list`,
  DELETE_USER_BLACKLIST: (userBlackListId: string) => `${baseUrl}/user-black-list/${userBlackListId}`,
  USER_ACTIVE_REMOVE_WITH_ID: (userId: string) => `${baseUrl}/admin/user-profile/${userId}`,

  // IMAGE
  IMAGE_LIST: `${baseUrl}/images`,
  IMAGE_SAVE: `${baseUrl}/images/save`,
  IMAGE_UPDATE: `${baseUrl}/images/update`,
  IMAGE_DELETE: `${baseUrl}/images/`,

  /** TILES WIDGET */
  TILE_WIDGET_API: `${baseUrl}/tiles-widget`,
  TILE_WIDGET_SORT: `${baseUrl}/tiles-widget/sort`,
  TILE_WIDGET_URL_WITH_ID: (id: string) => `${baseUrl}/tiles-widget/${id}`,
  TILE_WIDGET_ACTIVE_URL_WITH_ID: (id: string) => `${baseUrl}/tiles-widget/active/${id}`,
  PLAYER_PROFILE_API: `${baseUrl}/tiles-widget/player-profiles`,

  // SCHEDULE TILES WIDGET
  SCHEDULE_LIST_TILE_WIDGET: (widgetType: string) => `${baseUrl}/schedules/all?type=${widgetType}`,
  SCHEDULE_ADD_UPDATE_TILE_WIDGET: `${baseUrl}/tiles-widget/schedules/add-update`,
  DELETE_SCHEDULE_TILE_WIDGET: (widgetId: string) => `${baseUrl}/tiles-widget/schedules/${widgetId}`,
  GET_SCHEDULE_TILE_WIDGET: (widgetId: string, widgetType: string) =>
    `${baseUrl}/tiles-widget/schedules/${widgetId}?type=${widgetType}`,

  /** SHOP DISCOUNT */
  PRODUCT_CATALOG_DATA_API: `${baseUrl}/shop-discount/products/overwriteEcom`,
  PRODUCT_CATALOG_SORT_API: `${baseUrl}/shop-discount/products/sort`,
  PRODUCT_CATALOG_SYNC_API: `${baseUrl}/shop-discount/products/adminPortal`,
  PRODUCT_CATALOG_UPDATE_API: (id: string) => `${baseUrl}/shop-discount/products/${id}`,

  /** TEXTS */
  TEXT_LIST_API: `${baseUrl}/texts`,
  TEXT_CREATE_API: `${baseUrl}/texts/save`,
  TEXT_UPDATE_API: `${baseUrl}/texts/update`,
  TEXT_DELETE_API: (id: string) => `${baseUrl}/texts/${id}`,

  /** HOME PRODUCT */
  HOME_PRODUCT_DATA_API: `${baseUrl}/home-product/products/overwriteEcom`,
  HOME_PRODUCT_CREATE_API: `${baseUrl}/home-product/products/save`,
  HOME_PRODUCT_UPDATE_API: (id: string) => `${baseUrl}/home-product/products/${id}`,
  HOME_PRODUCT_DELETE_API: (id: string) => `${baseUrl}/home-product/products/${id}`,
  HOME_PRODUCT_SORT_API: `${baseUrl}/home-product/products/sort`,
  HOME_PRODUCT_DATA_ECOM_API: `${baseUrl}/home-product/products/adminPortal`,

  /** COACH_PROFILE */
  COACH_PROFILE_API: `${baseUrl}/coach-profile`,
  COACH_PROFILE_SORT: `${baseUrl}/coach-profile/sort`,
  COACH_PROFILE_URL_WITH_ID: (id: string) => `${baseUrl}/coach-profile/${id}`,
  COACH_PROFILE_ACTIVE_URL_WITH_ID: (id: string) => `${baseUrl}/coach-profile/active/${id}`,

  /** TOUR_STORY*/
  TOUR_STORY_API: `${baseUrl}/tour-story`,
  TOUR_STORY_LIST: `${baseUrl}/tour-story/get-list`,
  TOUR_STORY_SORT: `${baseUrl}/tour-story/sort`,
  DELETE_MULTIPLE_TOUR_STORY: `${baseUrl}/tour-story/delete/multiple`,
  TOUR_STORY_URL_WITH_ID: (id: string) => `${baseUrl}/tour-story/${id}`,
  TOUR_STORY_ACTIVE_URL_WITH_ID: (id: string) => `${baseUrl}/tour-story/active/${id}`,

  /** CARTNER_CONVOS*/
  QUESTION_LIST_API: `${baseUrl}/poll-questions`,
  QUESTION_SORT: `${baseUrl}/poll-questions/sort`,
  QUESTION_CREATE_API: `${baseUrl}/poll-questions/save`,
  QUESTION_UPDATE_STATUS_API: (id: string) => `${baseUrl}/poll-questions/status/${id}`,
  QUESTION_PERCENT_API: (id: string) => `${baseUrl}/poll-questions/percent/${id}`,
  QUESTION_URL_WITH_ID: (id: string) => `${baseUrl}/poll-questions/${id}`,
  ANSWER_CREATE_API: `${baseUrl}/poll-answers/save`,
  ANSWER_URL_WITH_ID: (id: string) => `${baseUrl}/poll-answers/${id}`,
  QUESTION_UPDATE_SCHEDULE: `${baseUrl}/poll-questions/schedules/add-update`,

  /** SHOP CATEGORY **/
  SHOP_CATEGORY_API: `${baseUrl}/shop-category`,
  SHOP_CATEGORY_LIST: `${baseUrl}/shop-category/get-list`,
  SHOP_CATEGORY_SORT: `${baseUrl}/shop-category/sort`,
  SHOP_CATEGORY_URL_WITH_ID: (id: string) => `${baseUrl}/shop-category/${id}`,
  SHOP_CATEGORY_ACTIVE_URL_WITH_ID: (id: string) => `${baseUrl}/shop-category/status/${id}`,

  /** GAME PROFILE **/
  GAME_PROFILE_API: `${baseUrl}/game-profiles`,
  GAME_PROFILE_ENTRY_CARD_API: `${baseUrl}/game-profiles/entry-card`,
  GAME_PROFILE_ENTRY_CARD_STATUS_API: `${baseUrl}/game-profiles/entry-card/status`,
  GAME_PROFILE_QUESTIONNAIRE_API: `${baseUrl}/game-profiles/questionnaire`,
  GAME_PROFILE_QUESTIONS_LIST_API: `${baseUrl}/game-profile-questions/list`,
  GAME_PROFILE_QUESTIONS_API: `${baseUrl}/game-profile-questions`,
  GAME_PROFILE_QUESTIONS_SORT_API: `${baseUrl}/game-profile-questions/sort`,
  GAME_PROFILE_QUESTIONS_UPDATE_STATUS_API: (id: string) => `${baseUrl}/game-profile-questions/${id}/status`,
  GAME_PROFILE_QUESTIONS_UPDATE_API: (id: string) => `${baseUrl}/game-profile-questions/${id}`,
  GAME_PROFILE_QUESTIONS_SUMMARY_API: (id: string) => `${baseUrl}/game-profile-questions/summary/${id}`,
  GAME_PROFILE_QUESTION_SETS_API: `${baseUrl}/game-profile-group-sets`,
  GAME_PROFILE_QUESTION_SET_DETAIL_API: (id: string) => `${baseUrl}/game-profile-group-sets/${id}`,
  GAME_PROFILE_QUESTION_SET_STATUS_API: (id: string) => `${baseUrl}/game-profile-group-sets/${id}/status`,
  GAME_PROFILE_QUESTIONS_DETAIL_API: (id: string) => `${baseUrl}/game-profile-questions/${id}`,
});
